/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedUserList } from '../models/PaginatedUserList';
import type { User } from '../models/User';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedUserList
     * @throws ApiError
     */
    public usersList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedUserList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public usersRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this Utilisateur.
         */
        id: number,
    }): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public usersToggleTechnicianStatusCreate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this Utilisateur.
         */
        id: number,
        requestBody: User,
    }): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/{id}/toggle_technician_status/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public usersBigchangeResourcesRetrieve(): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/bigchange_resources/',
        });
    }

    /**
     * @returns User
     * @throws ApiError
     */
    public usersCreateTechnicianCreate({
        requestBody,
    }: {
        requestBody: User,
    }): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/create_technician/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
